var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.001 33.0002C9.7167 33.0002 3.00098 26.2844 3.00098 18.0002C3.00098 9.71597 9.7167 3.00024 18.001 3.00024C26.2852 3.00024 33.001 9.71597 33.001 18.0002C33.001 26.2844 26.2852 33.0002 18.001 33.0002ZM18.001 30.0002C24.6284 30.0002 30.001 24.6277 30.001 18.0002C30.001 11.3728 24.6284 6.00024 18.001 6.00024C11.3736 6.00024 6.00098 11.3728 6.00098 18.0002C6.00098 24.6277 11.3736 30.0002 18.001 30.0002ZM18.001 15.8789L22.2436 11.6363L24.3649 13.7576L20.1223 18.0002L24.3649 22.2428L22.2436 24.3641L18.001 20.1215L13.7583 24.3641L11.637 22.2428L15.8797 18.0002L11.637 13.7576L13.7583 11.6363L18.001 15.8789Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.801396455e34c5167e766cd35ffd1343.svg";
export { ForwardRef as ReactComponent };